module.exports = __webpack_public_path__ + "img/image47.d4a22c12.png";